import React from "react";
import { useSelector } from "react-redux";
import acessos from "~/pages/Sistema/acessos";
import { tipoAcesso } from "~/config/definicoesPadrao";
import { Colors } from "~/config/Colors";

import { ThisButton } from "./styles";

function SubMenuButton({ selected, setComponentPath, currentModulo, menu, subMenu }) {
  const { auth: { perfil } } = useSelector((state) => state) || {};

  return (
    <ThisButton
      selected={selected} 
      ftColorSelect={selected ? Colors?.Color4 : Colors?.Color7}
      bgColorSelect={selected ? Colors?.Color2 : Colors?.Color13}
      onClick={() => {
        const Componente = acessos?.[tipoAcesso[perfil?.tipo]]?.[currentModulo?.path]?.[menu?.path]?.[subMenu?.path];

        if (typeof Componente === "function") {
          setComponentPath({
            moduloPath: currentModulo?.path,
            menuPath: menu?.path,
            subMenuPath: subMenu?.path,
          });
        }
      }}
    >
      <img src={require('~/assets/submenus/' + (selected ? "ativo/" : "desativo/") + subMenu?.icone + '.svg')} alt={subMenu.nome} />
      <p>{subMenu.nome}</p>
    </ThisButton>
  );
}

export default SubMenuButton;
